import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import { performanceOptimizations, seoMetrics } from './utils/performance'

// Performance monitoring
const reportWebVitals = ({ id, name, value }) => {
  if (window.gtag) {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      non_interaction: true,
    })
  }
}

// Initialize performance optimizations
performanceOptimizations.init()
seoMetrics.trackCoreWebVitals()
seoMetrics.trackPageLoad()

// Create app instance
const app = createApp(App)

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err)
  console.error('Component:', vm)
  console.error('Info:', info)
  
  // Send to error tracking service (example with console)
  if (process.env.NODE_ENV === 'production') {
    // TODO: Replace with your error tracking service
    console.error('Production error:', {
      error: err,
      component: vm?.$options?.name || 'Unknown',
      info,
      url: window.location.href,
      timestamp: new Date().toISOString()
    })
  }
}

// Navigation guards
router.beforeEach((to, from, next) => {
  // Add loading state
  document.body.classList.add('page-loading')
  next()
})

router.afterEach((to) => {
  // Remove loading state
  document.body.classList.remove('page-loading')
  
  // Track page views
  if (window.gtag) {
    window.gtag('config', process.env.VUE_APP_GA_ID, {
      page_path: to.fullPath
    })
  }
  
  // Update document title
  document.title = to.meta.title 
    ? `${to.meta.title} | Salasah`
    : 'Salasah - Your Digital Solutions Partner'
})

// Register plugins
app.use(router)
app.use(i18n)

// Mount app
app.mount('#app')

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered:', registration)
      })
      .catch(error => {
        console.log('SW registration failed:', error)
      })
  })
}

// Export for web vitals
export { reportWebVitals } 